// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { importProvidersFrom, NgZone } from '@angular/core';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './app/interceptors/auth.interceptor';

import { HttpClient } from "@angular/common/http";

// To support translations/locale
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { provideNgxMask } from 'ngx-mask';

import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
// import { getLoggerLevel } from './app/services/logging.service';
import { LoggingService } from './app/services/logging.service';
import { environment } from './environments/environment';

export function httpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
    // return new TranslateHttpLoader(http, "http://......", "");
  }

bootstrapApplication(AppComponent, {
    providers: [
      // {
      //     provide: NGXLoggerServerService,
      //     useClass: CustomLoggerServerService
      // },
      // {
      //   provide: NGXLoggerServerService,
      //   useFactory: (httpBackend: HttpBackend, ngZone: NgZone, dataExchangeService: DataExchangeService) => {
      //     const http = new HttpClient(httpBackend);
      //     return new CustomLoggerServerService(httpBackend, ngZone, http, dataExchangeService);
      //   },
      //   deps: [HttpBackend, NgZone, DataExchangeService]
      // },

      provideHttpClient(withInterceptors([authInterceptor])),
      importProvidersFrom(BrowserModule, ReactiveFormsModule, FormsModule, FontAwesomeModule, AppRoutingModule),
      provideAnimations(),
      importProvidersFrom(
        LoggerModule.forRoot({
            level: new LoggingService().getLoggerLevel(), 
            serverLogLevel: NgxLoggerLevel.ERROR, // Set desired log level for server
            serverLoggingUrl: environment.settings.portalUrl + '/common/logger'
          })
      ),    
      importProvidersFrom([TranslateModule.forRoot({
          loader: {
            provide: TranslateLoader,
            useFactory: httpLoaderFactory,
            deps: [HttpClient],
          },
        })
      ]),
      provideNgxMask(),
    ]
})
  .catch(err => console.error(err));
